import InputContainer from './InputContainer';

const CheckboxList = ({
    value,
    onChange,
    options,
    label,
    className,
    containerClassName,
    id,
    renderLabel,
    renderCheckbox,
    onUncheckAll,
}) => {
    value = value || [];
    function isChecked(thisValue) {
        return value.indexOf(thisValue) > -1;
    }

    function toggle(thisValue) {
        if (isChecked(thisValue)) {
            onChange(value.filter(v => v !== thisValue));
        } else {
            onChange([...value, thisValue]);
        }
    }

    const isAllSelected = value.length === options.length;
    const showSelectAll = options.length > 4;

    function toggleSelectAll() {
        if (isAllSelected) {
            // Deselect all
            if (typeof onUncheckAll === 'function') {
                onUncheckAll();
            } else {
                onChange([]);
            }
        } else {
            // Select all
            onChange(options.map(o => o.value));
        }
    }

    const optionsByGroup = Object.groupBy(options, o => o.group || '');

    return (
        <InputContainer label={label} className={className} id={id}>
            <div className={containerClassName}>
                {showSelectAll && (
                    <label className="flex flex-row items-start py-2">
                        <input
                            type="checkbox"
                            checked={isAllSelected}
                            className={`mr-2 mt-1`}
                            onChange={() => toggleSelectAll()}
                        />
                        Select all
                    </label>
                )}
                {Object.keys(optionsByGroup).map((groupName, idx) => (
                    <>
                        {!!groupName && (
                            <div
                                className={`font-medium ${idx > 0 ? 'mt-2' : ''}`}
                            >
                                {groupName}
                            </div>
                        )}
                        {optionsByGroup[groupName].map(opt => (
                            <label
                                className="flex flex-row items-start py-2"
                                key={opt.id ?? opt.value}
                            >
                                {typeof opt.value.startsWith === 'function' &&
                                     opt.value.startsWith('### ') && (
                                    <div className="font-medium">
                                        {opt.value.replace('### ', '')}
                                    </div>
                                )}
                                {(typeof opt.value.startsWith !== 'function' || !opt.value.startsWith('### ')) && (
                                    <>
                                        {typeof renderCheckbox === 'function' &&
                                            renderCheckbox({
                                                opt,
                                                isChecked: isChecked(opt.value),
                                                toggle: () => toggle(opt.value),
                                            })}
                                        {typeof renderCheckbox !== 'function' && (
                                            <input
                                                type="checkbox"
                                                value={opt.value}
                                                checked={isChecked(opt.value)}
                                                className={`mr-2 mt-1 ${opt.disabled ? '!bg-gray-400' : ''}`}
                                                onChange={() => toggle(opt.value)}
                                                disabled={!!opt.disabled}
                                            />
                                        )}
                                        <div
                                            className={`flex-1 ${opt.disabled ? 'text-gray-400' : ''}`}
                                        >
                                            {typeof renderLabel === 'function'
                                                ? renderLabel({ opt })
                                                : opt.label}
                                            {!!opt.subtext && (
                                                <div className="text-sm">
                                                    {opt.subtext}
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </label>
                        ))}
                    </>
                ))}
            </div>
        </InputContainer>
    );
};

export default CheckboxList;
